import { useState } from 'react';
import { useTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui';
import type { OrderDetail } from '@/lib/api-admin/types';
import { PrintDocumentModal } from './PrintDocumentModal';
import type { PrintDocumentKind } from './types';

interface PrintDocumentMenuProps {
  orderId: string | undefined;
  order: OrderDetail | undefined;
}

const KINDS: ReadonlyArray<PrintDocumentKind> = [
  'transaction-statement',
  'order-statement',
];

/**
 * 16차 TASK-8 — 주문상세 출력물 진입. 2종(거래명세서/주문내역서) 버튼.
 * 선택 시 PrintDocumentModal 로 미리보기 후 브라우저 인쇄.
 * 견적서는 BO 범위 밖(SF 장바구니에서 구현).
 */
export const PrintDocumentMenu = ({ orderId, order }: PrintDocumentMenuProps) => {
  const { t } = useTranslation('orders');
  const [activeKind, setActiveKind] = useState<PrintDocumentKind | null>(null);

  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        {KINDS.map((kind) => (
          <Button
            key={kind}
            type="button"
            variant="outline"
            size="md"
            onClick={() => setActiveKind(kind)}
            data-print-kind={kind}
          >
            {t(`orders.print.kind.${kind}`)}
          </Button>
        ))}
      </div>

      {activeKind ? (
        <PrintDocumentModal
          orderId={orderId}
          order={order}
          kind={activeKind}
          onClose={() => setActiveKind(null)}
        />
      ) : null}
    </>
  );
};
